"use client";

import Image from "next/image";
import Link from "next/link";

export default function BecomeTeacherPage() {
  return (
    <div className="overflow-hidden">
      <div>
        <div className="bg-white">
          {/* First Section */}
          <section className="bg-[#ef7e74]">
            <div className="rounded-b-semifull xsm:pb-8 bg-[#E9E9EA] pb-8 sm:pb-10 md:pb-14 lg:pb-16 xl:pb-20">
              <div className="rounded-b-semifull xsm:py-8 relative bg-[#27335d] py-8 text-white sm:py-10 md:py-12 lg:py-14 xl:py-16">
                <div className="mx-auto flex w-full max-w-[77%] flex-col items-center md:mt-[5.9%] md:max-w-[85%] md:flex-row md:items-start lg:max-w-[80%]">
                  <div className="mb-5 block md:hidden">
                    <Image
                      src="/images/RocketLandingsip/rocket.webp"
                      alt="Rocket"
                      width={200}
                      height={200}
                      className="animate-float h-44 w-auto object-contain"
                    />
                  </div>
                  <div className="mx-auto text-center md:text-start">
                    <p className="xsm:text-3xl text-xl font-bold sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl">
                      Share Your Knowledge,
                      <span className="block">Inspire Learners Worldwide!</span>
                    </p>
                  </div>
                </div>
                {/* Sign-up Button */}
                <div className="mt-1.5 flex flex-row justify-center md:mt-7 lg:mt-10">
                  <Link href="/auth?role=teacher" data-testid="becomeTeacherSignUpButton" className="mt-[5%] inline-block transform-gpu rounded-full border-b-8 border-black bg-[#4887F5] px-4 py-3 text-lg font-bold text-[#27335d] shadow-2xl transition-all duration-300 ease-out hover:bg-[#3666b9] active:scale-95 sm:px-6 sm:py-4 sm:text-xl md:px-10 md:py-5 md:text-2xl lg:px-14 lg:py-[1.6rem] lg:text-3xl">
                      Sign up as teacher
                  </Link>
                </div>
                <div className="absolute hidden sm:top-[20%] md:top-[4%] md:right-[10%] md:block md:rotate-45 lg:top-[5%] lg:right-[13%] xl:top-[31%] xl:right-[4%] xl:rotate-0 2xl:top-[37%] 2xl:right-[5%]">
                  <Image
                    src="/images/RocketLandingsip/rocket.webp"
                    alt="Rocket"
                    width={200}
                    height={200}
                    className="animate-float xsm:h-16 w-auto object-contain sm:h-20 md:h-24 lg:h-28 xl:h-64"
                  />
                </div>
                <div className="my-[5%] flex flex-col items-center justify-center">
                  <p className="lg w-full max-w-[77%] text-center text-xl font-bold text-white md:max-w-[85%] md:text-2xl lg:max-w-[80%] lg:text-4xl xl:text-5xl 2xl:max-w-[80%] 2xl:text-5xl 2xl:leading-snug">
                    Join our growing community of Arabic teachers and start
                    making a difference today!
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* Second Section */}
          <section className="bg-[#27335d]">
            <div className="rounded-b-semifull xsm:pb-12 bg-[#E9E9EA] pb-12 sm:pb-14 md:pb-24 lg:pb-28 xl:pb-32">
              <div className="rounded-b-semifull xsm:py-8 bg-[#ef7e74] py-8 text-white sm:py-10 md:py-12 lg:py-14 xl:py-16">
                {/* Intro */}
                <div className="xsm:mt-6 mt-6 text-center sm:mt-7 md:mt-8 lg:mt-9 xl:mt-10">
                  <h1 className="xsm:text-3xl text-3xl font-bold tracking-tight text-[#27335D] sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
                    Why teach with
                  </h1>
                  <h1 className="xsm:text-3xl pb-3 text-3xl font-bold tracking-tight text-[#27335D] sm:text-4xl md:pb-8 md:text-5xl lg:text-6xl xl:text-7xl">
                    us?
                  </h1>
                </div>
                {/* Cards */}
                <div className="xsm:mb-10 xsm:mt-8 xsm:gap-12 mt-8 mb-10 flex flex-wrap justify-center gap-12 sm:mt-10 sm:mb-12 sm:gap-14 md:mt-12 md:mb-14 md:gap-14 lg:mt-14 lg:mb-16 lg:gap-9 xl:mt-16 xl:mb-20 xl:gap-24">
                  {/* Card 1 */}
                  <div className="flex h-[214px] w-[225px] flex-col items-center justify-center rounded-[70px] border-b-8 border-[#482623] bg-[#27335d] text-center md:h-[235px] md:w-[280px]">
                    <div className="flex h-[214px] w-[225px] flex-col items-center justify-center rounded-[70px] border-4 border-[#4887f5] bg-[#27335d] text-center md:h-[235px] md:w-[280px]">
                      <div className="px-6 pb-2">
                        <Image
                          src={"/images/icon2.svg"}
                          alt={"icon3"}
                          height={100}
                          width={100}
                          className="mx-auto mt-2 h-10 w-10 md:h-14 md:w-14"
                        />
                        <h1 className="mt-2.5 mb-2 text-lg font-bold text-white md:text-xl">
                          Flexible Schedule
                        </h1>
                        <span className="text-sm text-white md:text-base">
                          Teach at your convenience
                          <span className="block">and set your own hours</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="flex h-[214px] w-[225px] flex-col items-center justify-center rounded-[70px] border-b-8 border-[#482623] bg-[#27335d] text-center md:h-[235px] md:w-[280px]">
                    <div className="flex h-[214px] w-[225px] flex-col items-center justify-center rounded-[70px] border-4 border-[#4887f5] bg-[#27335d] text-center md:h-[235px] md:w-[280px]">
                      <div className="px-6 pb-0.5">
                        <Image
                          src={"/images/icon3.svg"}
                          alt={"icon3"}
                          height={100}
                          width={100}
                          className="mx-auto mt-4 h-10 w-10 md:h-14 md:w-14"
                        />
                        <h1 className="text-lg font-bold text-white md:text-xl">
                          Earn More
                        </h1>
                        <span className="text-sm text-white md:text-base">
                          Competitive rates and
                          <span className="block">transparent payment</span>
                          <span className="block">system</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="flex h-[214px] w-[225px] flex-col items-center justify-center rounded-[70px] border-b-8 border-[#482623] bg-[#27335d] text-center md:h-[235px] md:w-[280px]">
                    <div className="flex h-[214px] w-[225px] flex-col items-center justify-center rounded-[70px] border-4 border-[#4887f5] bg-[#27335d] text-center md:h-[235px] md:w-[280px]">
                      <div className="px-6 pb-5">
                        <Image
                          src={"/images/icon4.svg"}
                          alt={"icon3"}
                          height={100}
                          width={100}
                          className="mx-auto mt-2 h-10 w-10 md:h-14 md:w-14"
                        />
                        <h1 className="mt-3 mb-1.5 text-lg font-bold text-white md:text-xl">
                          Global Reach
                        </h1>
                        <span className="text-sm text-white md:text-base">
                          Connect with learners from{" "}
                          <span className="lg:block">around the world</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Third Section */}
          <section className="bg-[#4887f5]">
            <div className="rounded-b-semifull xsm:pb-10 bg-[#E9E9EA] pb-10 sm:pb-12 md:pb-24 lg:pb-28 xl:pb-32">
              <div className="rounded-b-semifull xsm:pb-9 xsm:pt-2 bg-[#27335d] pt-2 pb-9 text-white sm:pt-3 sm:pb-8 md:pt-10 md:pb-20 lg:pt-12 lg:pb-24 xl:pt-16 xl:pb-28">
                {/* Title Section */}
                <div className="xsm:mt-6 mx-auto flex w-[80%] flex-row items-center justify-start sm:mt-8 md:mt-10 lg:mt-14 xl:mt-16">
                  <div className="text-start">
                    <p className="xsm:text-xl text-xl font-bold sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                      Unlock
                      <span className="block"> Your Teaching Power!</span>
                    </p>
                  </div>
                </div>
                {/* Dashboard Section */}
                <div className="xsm:mt-7 mx-auto mt-7 w-fit items-center justify-center sm:mt-10 md:mt-16 lg:mt-24 xl:mt-28">
                  <div className="flex w-full flex-row items-center justify-center rounded-t-xl bg-[#4887f5]">
                    <h1 className="xsm:text-xs py-3 text-xs font-bold text-[#27335D] sm:text-sm md:text-lg lg:text-2xl xl:py-6 xl:text-3xl">
                      Teacher Dashboard!
                    </h1>
                  </div>
                  {/* Dashboard Features */}
                  <div className="xsm:p-5 flex flex-col items-center justify-center rounded-b-xl border-2 border-[#4887F5] p-5 sm:p-6 md:p-8 lg:p-10 xl:p-12">
                    <div className="xsm:gap-5 flex flex-col items-center gap-5 sm:gap-6 md:gap-7 lg:gap-8 xl:gap-11">
                      <div className="xsm:text-xs flex w-full flex-row items-center justify-center rounded-2xl border-2 border-[#4887f5] bg-[#F9D17B] px-4 py-3 text-xs font-bold text-[#27305D] sm:text-sm md:text-lg lg:px-8 lg:py-5 lg:text-xl xl:px-10 xl:py-7 xl:text-2xl">
                        Manage schedules and bookings
                      </div>
                      <div className="xsm:text-xs flex w-full flex-row items-center justify-center rounded-2xl border-2 border-[#4887f5] bg-[#F9D17B] px-4 py-3 text-xs font-bold text-[#27305D] sm:text-sm md:text-lg lg:px-8 lg:py-5 lg:text-xl xl:px-10 xl:py-7 xl:text-2xl">
                        Track earnings and payments
                      </div>
                      <div className="xsm:text-xs flex w-full flex-row items-center justify-center rounded-2xl border-2 border-[#4887f5] bg-[#F9D17B] px-4 py-3 text-xs font-bold text-[#27305D] sm:text-sm md:text-lg lg:px-8 lg:py-5 lg:text-xl xl:px-10 xl:py-7 xl:text-2xl">
                        Monitor student progress and feedback
                      </div>
                    </div>
                  </div>
                </div>
                {/* Sign-up Button */}
                <div className="xsm:mt-7 mt-7 flex flex-col items-center sm:mt-10 md:mt-16 lg:mt-20 xl:mt-24">
                  <Link href="/auth?role=teacher" data-testid="becomeTeacherDashboardSignUpButton" className="xsm:px-4 xsm:py-3 xsm:text-lg inline-block transform-gpu rounded-full border-b-8 border-black bg-[#4887F5] px-4 py-3 text-lg font-bold text-[#27335D] shadow-2xl transition-all duration-300 ease-out hover:bg-[#3c6ec4] active:scale-95 sm:px-6 sm:py-4 sm:text-xl md:px-8 md:py-5 md:text-2xl lg:px-10 lg:py-6 lg:text-3xl xl:px-12 xl:py-7 xl:text-4xl">
                      Sign up as teacher
                  </Link>
                </div>
              </div>
            </div>
          </section>
          {/* Fourth Section */}
          <section className="bg-[#27335d]">
            <div className="rounded-b-semifull xsm:pb-10 bg-[#E9E9EA] pb-10 sm:pb-12 md:pb-24 lg:pb-28 xl:pb-32">
              <div className="rounded-b-semifull xsm:pb-9 xsm:pt-2 bg-[#4887f5] pt-2 pb-9 text-white sm:pt-3 sm:pb-8 md:pt-10 md:pb-20 lg:pt-12 lg:pb-24 xl:pt-16 xl:pb-28">
                {/* Intro */}
                <div className="mt-10 text-center">
                  <h1 className="xsm:text-xl text-xl font-bold tracking-tight text-[#27335D] sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                    Share Your Passion and
                  </h1>
                  <h1 className="xsm:text-xl pb-3 text-xl font-bold tracking-tight text-[#27335D] sm:text-2xl md:pb-3 md:text-5xl lg:text-6xl xl:text-7xl">
                    Inspire Learners
                  </h1>
                  <h1 className="xsm:text-xl pb-3 text-xl font-bold tracking-tight text-[#27335D] sm:text-2xl md:pb-8 md:text-5xl lg:text-6xl xl:text-7xl">
                    Worldwide!
                  </h1>
                  {/* Steps for MD, LG, XL... */}
                  <div className="mx-auto hidden w-fit flex-col items-center justify-center pt-20 pb-10 md:flex">
                    {/* Steps with Line */}
                    <div className="relative flex w-full items-center justify-center">
                      {/* Dashed Line */}
                      <div className="absolute top-[29px] right-[70px] left-[70px] z-10 mx-auto h-[4px] w-[80%] border-b-4 border-dashed border-[#F6C65A]"></div>
                      {/* Step 1 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-white bg-[#F6C65A] text-2xl font-bold text-[#27335d]">
                          <p>1</p>
                        </div>
                        {/* Text 1 */}
                        <div className="flex flex-col items-center text-center">
                          <h1 className="font-bold md:text-lg lg:text-xl xl:text-2xl">
                            Sign up
                          </h1>
                          <p className="font-medium md:text-sm lg:text-base xl:text-lg">
                            Create your teacher
                            <span className="block">
                              profile in just a few clicks!
                            </span>
                          </p>
                        </div>
                      </div>
                      {/* Step 2 */}
                      <div className="z-20 flex flex-col items-center md:mx-[110px] lg:mx-[150px] xl:mx-[200px]">
                        {" "}
                        {/* Reduced spacing */}
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>2</p>
                        </div>
                        {/* Text 2 */}
                        <div className="flex flex-col items-center text-center">
                          <h1 className="font-bold md:text-lg lg:text-xl xl:text-2xl">
                            Get approved
                          </h1>
                          <p className="font-medium md:text-sm lg:text-base xl:text-lg">
                            By our team
                            <span className="block">in few minutes</span>
                          </p>
                        </div>
                      </div>
                      {/* Step 3 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>3</p>
                        </div>
                        {/* Text 3 */}
                        <div className="flex flex-col items-center text-center">
                          <h1 className="font-bold md:text-lg lg:text-xl xl:text-2xl">
                            Start earning
                          </h1>
                          <p className="font-medium md:text-sm lg:text-base xl:text-lg">
                            By teaching students
                            <span className="block">
                              from all over the world!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Steps for SM, XS, and General: Vertical Layout */}
                  <div className="mx-auto flex w-fit flex-col items-center justify-center pt-10 pb-10 md:hidden">
                    {/* Steps with Line */}
                    <div className="relative flex flex-col items-center justify-center">
                      {/* Step 1 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-white bg-[#F6C65A] text-2xl font-bold text-[#27335d]">
                          <p>1</p>
                        </div>
                        {/* Text 1 */}
                        <div className="mt-2 flex flex-col items-center text-center">
                          <h1 className="text-lg font-bold sm:text-xl">
                            Sign up
                          </h1>
                          <p className="text-sm font-medium sm:text-base">
                            Create your teacher
                            <span className="block">
                              profile in just a few clicks!
                            </span>
                          </p>
                        </div>
                      </div>

                      {/* Vertical Dashed Line */}
                      <div className="my-4 h-12 border-l-4 border-dashed border-[#F6C65A]"></div>

                      {/* Step 2 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>2</p>
                        </div>
                        {/* Text 2 */}
                        <div className="mt-2 flex flex-col items-center text-center">
                          <h1 className="text-lg font-bold sm:text-xl">
                            Get approved
                          </h1>
                          <p className="text-sm font-medium sm:text-base">
                            By our team
                            <span className="block">in few minutes</span>
                          </p>
                        </div>
                      </div>

                      {/* Vertical Dashed Line */}
                      <div className="my-4 h-12 border-l-4 border-dashed border-[#F6C65A]"></div>

                      {/* Step 3 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>3</p>
                        </div>
                        {/* Text 3 */}
                        <div className="mt-2 flex flex-col items-center text-center">
                          <h1 className="text-lg font-bold sm:text-xl">
                            Start earning
                          </h1>
                          <p className="text-sm font-medium sm:text-base">
                            By teaching students
                            <span className="block">
                              from all over the world!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Sign-up Button */}
                  <div className="xsm:mt-2 mt-2 flex flex-col items-center sm:mt-5 md:mt-12 lg:mt-14 xl:mt-16">
                    <Link href="/auth?role=teacher" data-testid="becomeTeacherStepsSignUpButton" className="xsm:px-4 xsm:py-3 xsm:text-lg inline-block transform-gpu rounded-full border-b-8 border-black bg-[#1849A9] px-4 py-3 text-lg font-bold text-white shadow-2xl transition-all duration-300 ease-out hover:bg-[#1848a9ce] active:scale-95 sm:px-6 sm:py-4 sm:text-xl md:px-8 md:py-5 md:text-2xl lg:px-10 lg:py-6 lg:text-3xl xl:px-12 xl:py-7 xl:text-4xl">
                        Sign up as teacher
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Fifth Section */}
          <section>
            <div className="rounded-b-semifull xsm:pb-7 bg-[#E9E9EA] pb-7 sm:pb-9 md:pb-24 lg:pb-28 xl:pb-32">
              <div className="rounded-b-semifull xsm:pb-9 xsm:pt-2 bg-[#27335d] pt-2 pb-9 text-white sm:pt-3 sm:pb-8 md:pt-10 md:pb-20 lg:pt-12 lg:pb-24 xl:pt-16 xl:pb-28">
                {/* Title Section */}
                <div className="xsm:mt-6 mx-auto flex w-[80%] flex-row items-center justify-start sm:mt-8 md:mt-10 lg:mt-14 xl:mt-16">
                  <div className="text-start">
                    <p className="xsm:text-xl text-xl font-bold sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                      Real Stories, Real Impact!
                    </p>
                  </div>
                </div>
                <div id="slider" className="py-10">
                  <div className="wrapper text-start">
                    <div className="itemLeft item1">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 1"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item2">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 2"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item3">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 3"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item4">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher2.2.png"
                          alt="Story 4"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item5">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher3.2.png"
                          alt="Story 5"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item6">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 6"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item7">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 7"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item8">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 8"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="wrapper text-start">
                    <div className="itemRight item1">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher2.2.png"
                          alt="Story 1"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item2">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 2"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item3">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher3.2.png"
                          alt="Story 3"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item4">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 4"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item5">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher2.2.png"
                          alt="Story 5"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item6">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 6"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item7">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 7"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item8">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 8"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="font-bold text-black">
                            FIRST NAME FAMILY NAME
                          </p>
                          <p className="text-sm text-gray-500">
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Provident exercitationem magni dignissimos
                            maxime quasi sapiente repellendus?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
